import pageScrollState from '../lib/page-scroll-state';
import eventBus from '../lib/event-bus';
import FocusableElements from '../classes/FocusableElements';
import on from '../lib/on';

const openModal = (modal) => {
    // eslint-disable-next-line no-param-reassign
    modal = typeof modal === 'string' ? document.getElementById(modal) : modal;
    pageScrollState.fix();
    if (modal.dataset.bgId) {
        document.getElementById(modal.dataset.bgId).classList.add('active');
    }
    modal.classList.add('active');
    eventBus.emit('modalOpened', modal);

    const modalElements = new FocusableElements(modal);
    modalElements.firstReal.focus();

    on(modalElements.all, 'blur', (e) => {
        if (e.relatedTarget?.classList.contains('focus-trap')) {
            modalElements.first.focus();
        }
        // eslint-disable-next-line no-useless-return
        if (modalElements.all.includes(e.relatedTarget)) return;
    });
};
const closeModal = (modal) => {
    // eslint-disable-next-line no-param-reassign
    modal = typeof modal === 'string' ? document.getElementById(modal) : modal;
    if (modal.dataset.bgId) {
        document.getElementById(modal.dataset.bgId).classList.remove('active');
    }
    modal.classList.remove('active');
    pageScrollState.unfix();
    eventBus.emit('modalClosed', modal);

    const modalId = modal.getAttribute('id');
    // eslint-disable-next-line no-unused-vars
    const element = document.querySelector(`.modal-opener[data-modal-id='${modalId}']`).focus();
};
[...document.querySelectorAll('.modal')].forEach((modal) => {
    if (modal.dataset.bgId && modal.getAttribute('id') !== 'notice-pop-up') {
        document.getElementById(modal.dataset.bgId).addEventListener('click', () => {
            closeModal(modal);
        });
    } else if (modal.getAttribute('id') !== 'notice-pop-up') {
        modal.addEventListener('click', () => {
            closeModal(modal);
        });
    }
    const modalCloseBtns = [...modal.querySelectorAll('.close-btn')];
    if (modalCloseBtns.length > 0) {
        modalCloseBtns.forEach((item) => item.addEventListener('click', () => closeModal(modal)));
    }

    const modalWindow = modal.querySelector('.window');
    if (modalWindow) {
        modalWindow.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }
});
[...document.querySelectorAll('.modal-opener')].forEach((modalOpener) => {
    modalOpener.addEventListener('click', () => {
        [...document.querySelectorAll('.modal')].forEach((modal) => {
            if (modal.classList.contains('active')) closeModal(modal);
        });
        openModal(modalOpener.dataset.modalId);
    });
});
